export default class AbstractCommand {
	execute(_successCallback, _failCallback) {
		throw new Error('Trying to use `execute` on AbstractCommand');
	}
}
